
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageIcon } from '@/utils/types'
import Offset from '@/components/common/flex-message/forms/Offset.vue'
import MediaInput from '@/components/common/ui/MediaInput.vue'

@Options({
  components: { MediaInput, Offset },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Icon extends Vue {
  @Prop()
  modelValue!: IFlexMessageIcon

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageIcon) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'アイコン',
        value: 'icon',
      },
    ]
  }

  get marginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  get sizeList() {
    return ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', '3xl', '4xl', '5xl']
  }

  get trueFalseList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ]
  }

  get validateRule() {
    return {
      url: this.$t('validate.url_validation'),
    }
  }

  aspectRatioValidate(val) {
    if (!val) return true

    const match = /^(\d{1,5}(?:\.\d+)?):(\d{1,5}(?:\.\d+)?)$/.exec(val)
    if (!match) return false

    const width = parseFloat(match[1])
    const height = parseFloat(match[2])

    if (width < 1 || width > 100000 || height < 1 || height > 100000) {
      return false
    }

    return height <= width * 3
  }

  marginValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.marginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  sizeValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.sizeList.includes(val)
    return !(!isPx && !isKeyword)
  }

  urlValidate(val) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
      'i'
    )
    return urlPattern.test(val)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
